<template>
    <div class="content">
        <div class="row">
          <div class="col">
              <div class="card" >
              <div class="card-header">
                <div class="row">
                   
                <div class="col">
                </div>
                </div>     
              </div>
              <div class="card-body">
                
                <div class="row" v-for="(islem , index) in getLogs">
                     <div class="col mt-3" >
                    <p><strong>TARİH : </strong>{{islem.date}}</p>
                </div>
                <div class="col mt-3" >
                    <p><strong>KULLANICI : </strong>{{islem.kullanici}}</p>
                </div>
                <div class="col mt-3" >
                    <p><strong>İŞLEM : </strong>{{islem.islem}}</p>
                </div>
                
                </div>
         
              </div>
           
            </div>
          </div>
         
        </div>
      </div>
</template>
<script>
import { mapGetters} from "vuex";

export default {
    computed : {
      ...mapGetters(["getLogs"]),
     
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Log.vue